import React, {Component} from 'react';

import { ReactComponent as ReclusterIcon } from '../images/recluster.svg'
import { ReactComponent as CompassBubble } from '../images/bubble.svg'

import styles from './Compass.module.scss'

type CompassProps = {
  angle: number,
  hidden: boolean,
  handleClick: Function
}

class Compass extends Component<CompassProps, {}> {
  goToCentroid = () => {
    this.props.handleClick();
  }

  render() {
    let bubbleStyle = {
      transform: 'translateX(-20%) rotate(' + (this.props.angle) + 'deg)',
    };

    return (
      <div className={this.props.hidden ? styles.hidden : styles.compass} onClick={this.goToCentroid}>
        <CompassBubble style={bubbleStyle} className={styles.bubble} />
        <ReclusterIcon className={styles.icon} />
      </div>
    );
  }
}

export default Compass;

